export default __webpack_public_path__ + "e1e0d55.png";